import { computed, observable, action } from 'mobx';
import get from 'lodash/get';
import groupBy from 'lodash/groupBy';
import { Services } from '../services';
import { TListCommentariesResponseBody } from '@kurtosys/ksys-api-client/dist/models/requests/config/TListCommentariesResponseBody';
import { BaseStore, ConfigStore, DataStore } from '.';

interface CommentariesByFundType {
    [fundType: string]: CommentariesByModuleId;
}

interface CommentariesByModuleId {
    [moduleId: string]: CommentariesByKey;
}

interface CommentariesByKey {
    [key: string]: Commentary;
}

interface Commentary {
    key: string;
    type: string;
    text: string;
}

export class CommentaryStore extends BaseStore {
    @observable.ref rawCommentaries: TListCommentariesResponseBody = [];
    @observable.ref commentariesDictionary: { [key: string]: string };
    @observable.ref
    commentariesByFundType: CommentariesByFundType = {};

    @computed
    get dataStore(): DataStore {
        return this.stores && this.stores.data;
    }
    @computed
    get services(): Services {
        return this.dataStore && this.dataStore.services;
    }
    @computed
    get config(): ConfigStore {
        return this.dataStore && this.dataStore.config;
    }
    @computed
    get culture(): string {
        return this.dataStore && this.dataStore.culture;
    }
    @computed
    get commentariesByKey(): CommentariesByKey {
        if (this.dataStore) {
            const { config } = this.dataStore;
            const fundType = config.selectedFundType.fundType;
            const moduleId = config.selectedModule.id;
            return (
                this.commentariesByFundType &&
                this.commentariesByFundType[fundType] &&
                this.commentariesByFundType[fundType][moduleId]
            );
        }
        return {};
    }

    // Get commentaries
    @action
    getGlobalCommentaries = async () => {
        try {
            if (this.services) {
                const commentaryTypes =
                    this.config &&
                    this.config.globalConfig &&
                    this.config.globalConfig.commentaryTypes;

                if (commentaryTypes) {
                    this.rawCommentaries = await this.services.getGlobalCommentaries(
                        this.config &&
                            this.config.globalConfig &&
                            this.config.globalConfig.commentaryTypes
                    );
                    const commentaries = groupBy(
                        this.rawCommentaries,
                        'commentaryType'
                    );

                    for (const c in commentaries) {
                        if (c) {
                            const commentary =
                                commentaries[c][0].commentaries.find(
                                    commentaryContent =>
                                        commentaryContent.culture ===
                                        this.culture
                                ) ||
                                commentaries[c][0].commentaries.find(
                                    commentaryContent =>
                                        commentaryContent.culture ===
                                        this.config.defaultCulture
                                );

                            commentaries[c] = get(commentary, 'commentary', '');
                        }
                    }

                    this.commentariesDictionary = commentaries;
                    this.stores.query.loadDefaultContext();
                }
            }
        } catch (e) {
            console.warn(e);
        }
    };
}



// WEBPACK FOOTER //
// ./src/stores/CommentaryStore.tsx